import { parseCmsCasting } from '../../cmsCasting';
import type { Question, QuestionType } from '../../types';

/** Shape returned inside `schema_data` section arrays from RogerDocs. */
export interface FormTreeQuestionInput {
  qid: string;
  question: string;
  type?: string | null;
  values?: string[] | null;
  value_description?: Record<string, string> | null;
  cms_casting?: unknown;
  /** Top-level Roger-Docs blank policy; omitted/``""`` means mechanical blank. */
  unanswered_value?: string | null;
  subitems?: Record<string, FormTreeQuestionInput[]> | null;
}

const KNOWN_TYPES: QuestionType[] = [
  'radio',
  'text',
  'number',
  'date',
  'multiselect',
];

function normalizeType(t: unknown): QuestionType {
  if (typeof t === 'string' && KNOWN_TYPES.includes(t as QuestionType)) {
    return t as QuestionType;
  }
  return 'text';
}

function convertRow(row: FormTreeQuestionInput): Question {
  const base: Question = {
    qid: row.qid,
    question: row.question ?? '',
    type: normalizeType(row.type),
  };
  if (row.values && row.values.length > 0) base.values = row.values;
  if (row.value_description) base.value_description = row.value_description;
  if (typeof row.unanswered_value === 'string' && row.unanswered_value !== '') {
    base.unanswered_value = row.unanswered_value;
  }
  const cms_casting = parseCmsCasting(row.cms_casting);
  if (cms_casting) base.cms_casting = cms_casting;
  if (row.subitems && Object.keys(row.subitems).length > 0) {
    base.subitems = {};
    for (const [parentKey, subRows] of Object.entries(row.subitems)) {
      base.subitems[parentKey] = (subRows ?? []).map(convertRow);
    }
  }
  return base;
}

export function formTreeSectionToQuestions(
  rows: FormTreeQuestionInput[] | null | undefined
): Question[] {
  if (!rows || rows.length === 0) return [];
  return rows.map(convertRow);
}
